import { forwardRef, type Ref, type SVGProps } from "react";
const IconProfessionalFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M20 3c.406-.001.778.227.96.588L22.7 7.06H28a2.003 2.003 0 0 1 2 1.991v3.993a8.9 8.9 0 0 1-2 5.626c-1.899 1.067-4.707 1.61-6.903 1.638V18.89a.5.5 0 0 0-.5-.499h-1a.5.5 0 0 0-.5.499v1.4l-.035-.004h-5.989V18.89a.5.5 0 0 0-.5-.499h-1a.496.496 0 0 0-.5.499v1.42c-2.22-.001-5.124-.545-7.072-1.64v1.657s1.108.472 1.572.686c1.26.58 3.497.848 5.5.848v2.015a.495.495 0 0 0 .5.499h1a.5.5 0 0 0 .5-.5v-2.036h5.99l.034-.004v2.04a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5V21.86c1.959-.015 4.108-.284 5.333-.848.455-.21 1.528-.668 1.57-.686v3.687A4.995 4.995 0 0 1 23 29H9c-2.761-.001-5-2.233-5-4.987V18.67a8.9 8.9 0 0 1-2-5.63V9.05a2.003 2.003 0 0 1 2-1.99h5.3l1.74-3.472A1.07 1.07 0 0 1 12 3zm-8.3 4.06h8.6l-.96-1.926h-6.68z"
      clipRule="evenodd"
    />
    <path fill="currentColor" d="M28.002 20.326H28v-1.657h.002z" />
  </svg>
);
const ForwardRef = forwardRef(IconProfessionalFilledSVG);
ForwardRef.displayName = "IconProfessionalFilled";
export { ForwardRef as IconProfessionalFilled };
